module.exports = __webpack_public_path__ + "img/play_color.a2132a9f.svg";